if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');

        this.hideUnselectedColor();
        // this.hideDisabledSizes();
      }

      // hideDisabledSizes = () => {
      //   const container = document.querySelector("variant-selects");
      //   if( container){
      //     container.querySelectorAll(".disabled").forEach((element) => {
      //       element.nextElementSibling.style.display = "none";
      //     });
      //   }
      // };

      
        
        
      removeClass = () => {
        const listItems = document.querySelectorAll(
            ".product-gallery__item"
          );
        listItems.forEach((li) => {
          li.classList.remove("hide-img");
        });
      };

      checkSelectedStyle= (selectedStyle) => {
        this.removeClass();
        const styleRef = document.querySelector("[data-style-variant-images]");
        const styleRefJson = JSON.parse(styleRef.innerHTML);
        const styleOpts = styleRefJson.styleOpts.split(',');
        const styleImgOpts = styleRefJson.styleImgOpts.split(',');

        const listItems = document.querySelectorAll(
            ".product-gallery__item"
          );
        
        let selectedIndex = 0;
        let x = 0;
        
        styleOpts.forEach((opt) => {
            if(selectedStyle === opt ){
              selectedIndex = x
            }
            x++;
        });
        
        x = 0;
        let display = "none";
        let i = 0;
        listItems.forEach((item) => {
          const img = item.dataset.src;
          if(img.includes(styleImgOpts[selectedIndex])){
            document.querySelector(".product-gallery__featured img").src = item.querySelector("img").src;
            item.classList.add("hide-img");
          }
        });
      }

      checkSelectedColor = (selectedColor) => {
        this.removeClass();
        const colorRef = document.querySelector("[data-color-variant-images]");
        const colorRefJson = JSON.parse(colorRef.innerHTML);
        const colorOpts = colorRefJson.colorsOpts.split(',');
        const colorImgOpts = colorRefJson.colorsImgOpts.split(',');

        const listItems = document.querySelectorAll(
            ".product-gallery__item"
          );
        
        let selectedIndex = 0;
        let x = 0;
        
        colorOpts.forEach((opt) => {
            if(selectedColor === opt ){
              selectedIndex = x;
              console.log('selectedIndex', selectedIndex)
            }
            x++;
        });
        
        x = 0;
        let display = "none";
        let i = 0;
        listItems.forEach((item) => {
          const img = item.dataset.src;
          console.log('img', img);
            if(selectedIndex == 0) {
              console.log('inif')
              if(i == 0) {                
                console.log('in444')
                document.querySelector(".product-gallery__featured img").src = item.querySelector("img").src;
                item.classList.add("hide-img");
              }
              
              if(x==1 ||  img.includes(colorImgOpts[1]) ){      
                console.log('in555')
                item.classList.add("hide-img");
                x=1;
              }
            }else{              
              console.log('inelse')
              if(x==1 || img.includes(colorImgOpts[selectedIndex]) ){                
                console.log('inif11')
                if(img.includes(colorImgOpts[selectedIndex])) {
                  document.querySelector(".product-gallery__featured img").src = item.querySelector("img").src;
                  item.classList.add("hide-img");
                }
                if(colorImgOpts[selectedIndex + 1]){
                  if(img.src.includes(colorImgOpts[selectedIndex + 1])){
                    item.classList.add("hide-img");
                    x=0;
                  }
                }else{
                  x=1;
                }
              }else{
                console.log('inelse11')
                item.classList.add("hide-img");
              }
              console.log('img.src',img.src);
            }
         i++;
        });
      }

      checkSelectedSize= (selectedSize) => {
        this.removeClass();
        const sizeRef = document.querySelector("[data-size-variant-images]");
        const sizeRefJson = JSON.parse(sizeRef.innerHTML);
        const sizeOpts = sizeRefJson.sizeOpts.split(',');
        const sizeImgOpts = sizeRefJson.sizeImgOpts.split(',');

        const listItems = document.querySelectorAll(
            ".product-gallery__item"
          );
        
        let selectedIndex = 0;
        let x = 0;
        
        sizeOpts.forEach((opt) => {
            if(selectedSize === opt ){
              selectedIndex = x
            }
            x++;
        });
        
        x = 0;
        let display = "none";
        let i = 0;
        listItems.forEach((item) => {
          const img = item.dataset.src;
          if(img.includes(sizeImgOpts[selectedIndex])) {
            document.querySelector(".product-gallery__featured img").src = item.querySelector("img").src;
            item.classList.add("hide-img");
          }
        });
      }

      hideUnselectedColor = () => {
        let checkedColorRadio, checkedStyleRadio;
        const colorFieldset = document
          .querySelectorAll(
            "fieldset.js.product-form__input legend.form__label"
          )
          .forEach((element) => {
            
            if (element && element.textContent.trim() === "Style") {
              checkedStyleRadio = element.parentElement.querySelectorAll(
                'input[type="radio"]'
              );
              const checkedStyleRadioChecked = element.parentElement.querySelector(
                'input[type="radio"]:checked'
              );
              if(checkedStyleRadio.length > 1)
                this.checkSelectedStyle(checkedStyleRadioChecked.value);
            }else if (element && element.textContent.includes("Color")) {
              checkedColorRadio = element.parentElement.querySelectorAll(
                'input[type="radio"]'
              );
              const checkedColorRadioChecked = element.parentElement.querySelector(
                'input[type="radio"]:checked'
              );
              if(checkedColorRadio.length > 1)
                this.checkSelectedColor(checkedColorRadioChecked.value);
            }else if (element && element.textContent.trim() === "Size") {
              const checkedSizeRadio = element.parentElement.querySelectorAll(
                'input[type="radio"]'
              );
              const checkedSizeRadioChecked = element.parentElement.querySelector(
                'input[type="radio"]:checked'
              );
              console.log("checkedColorRadio.length",  checkedColorRadio.length)
              if((checkedColorRadio.length < 2 && checkedStyleRadio.length < 2) && checkedSizeRadio.length > 1)
                this.checkSelectedSize(checkedSizeRadioChecked.value);
            }
          });
         initialimagelist();
      };

      
      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}


// BOF YWV PRODUCT IMAGE SLIDER SCRIPTS
$(document).ready(function(){
  renderowlbutton();

  function clickFirstSize(){
    setTimeout(function(){
      console.log('clickFirstSize')
      const all_Fieldsets = document.querySelectorAll("fieldset.product-form__input");
      if(all_Fieldsets){
          all_Fieldsets.forEach((fieldset) => {
            let legend = fieldset.querySelector('legend');
              if (legend.textContent.trim() == "Size") {  
                //loop through all inputs and click first not disabled input
                // fieldset.querySelector('input:not(".disabled")').click();      
                
                const inputs = fieldset.querySelectorAll('input:not(.disabled)');                
                // Click the first input in the list
                if (inputs.length > 0) {
                    inputs[0].click();
                }
              }
          });
      }
    }, 300);
  }
  const all_Fieldsets = document.querySelectorAll("fieldset.product-form__input");
  if(all_Fieldsets){
      all_Fieldsets.forEach((fieldset) => {
        let legend = fieldset.querySelector('legend');
        if (legend.textContent.trim() == "Style") {
          let all_inputs = fieldset.querySelectorAll('input');
          if(all_inputs){
            all_inputs.forEach(function(inpEle){
              inpEle.addEventListener('change', clickFirstSize);
            });
          }
        }
      });
  }
  
}); 

var imgindexglobal = -2;
if($(window).width() < 992){
    imgindexglobal = -1;
}

$(document).ready(function(){
    $(".mob-thumb-slider .slider-product-img-carousel").owlCarousel({
    loop:true,
    center:true,
    lazyLoad:true,
    margin:0,
    nav:true,
    navText: ["",""],
    dots: false,
    items: 5,
    responsiveClass:true,
    mouseDrag : false,
    touchDrag : false,
    responsive:{
       0:{
          items:3,
          smartSpeed : 150,
          nav:true
       },
       992:{
          items:5,
          nav:true
       }
    }
  });
    $('.product-img-carousel').owlCarousel({
    loop: true,
    lazyLoad:true,
    nav: true,
    margin: 10,
    dots: true,
    singleItem: true,
    items: 1,
    responsiveClass:true,
    responsive:{
      0:{
        items:1,
        nav:false,
        smartSpeed : 150,
        dots:true,
      },
      500:{
        items:1,
        nav:true,
      }
    }
  });
	
	$('.product-img-carousel .owl-nav').click(function(){
		$(".slider-item").removeClass('active');
		// $(".slider-item").css('opacity',0.7)
		var img_data_id = $('.product-img-carousel .active .item').attr('data-id')
		$(".slider-item").each(function(){
			if($(this).attr('data-id') == img_data_id){ 
				$(this).addClass('active');
			} 
		});
	});
	
	$(document).on('click','.slider-item',function(){
		$(".slider-item").removeClass("active");
		var img_data_id = $(this).attr('data-id');
		$(".slider-item").each(function(){
			if($(this).attr('data-id') == img_data_id){ 
				$(this).addClass('active');
			} 
		})
		var imgindex = 0;
        $(".product-img-carousel .owl-item:not(.cloned) .item").each(function(){
			var dataid = $(this).attr("data-id");
			if(dataid == img_data_id){
				$('.product-img-carousel').trigger('to.owl.carousel', imgindex);
				return false;
			} 
			imgindex++;
		});
	});
	$(document).on('click','.closeproduct',function(){
		$('.product-popup').hide();
	});
	$(document).on('click','.prodimg',function(){
		$('.product-popup').css('display', 'flex');
	});
	
	$('.product-img-carousel .owl-nav').click(function(){
    $(".slider-item").removeClass('active');
    // $(".slider-item").css('opacity',0.7)
    var img_data_id = $('.product-img-carousel .active .item').attr('data-id')
    $(".slider-item").each(function(){
       if($(this).attr('data-id') == img_data_id){ 
          $(this).addClass('active');
       } 
    });
  });

});

function initialimagelist(){
  let optwhitedisplay = "";
  let mobthumbisplay = "";
  const featuredimg = document.querySelectorAll(".product-gallery__featured img");
  const imglist = document.querySelectorAll(".product-gallery__grid div:not(.hide-img) img");

  featuredimg.forEach((element) => {
    let imgsrc = element.getAttribute("src");
    let imgid = element.getAttribute("data-id");
    optwhitedisplay += '<div class="item" data-id="'+imgid+'">';
    optwhitedisplay += '<img src="'+imgsrc+'">';
    optwhitedisplay += "</div>";

    mobthumbisplay += '<div  class="all_image_manage slider-item active" data-id="'+imgid+'">';
    mobthumbisplay += '<img src="'+imgsrc+'" class="prodimg owl-lazy">';
    mobthumbisplay += "</div>";
  });

  imglist.forEach((element) => {
    let imgsrc = element.getAttribute("src");
    let imgid = element.getAttribute("data-id");
    optwhitedisplay += '<div class="item" data-id="'+imgid+'">';
    optwhitedisplay += '<img src="'+imgsrc+'">';
    optwhitedisplay += "</div>";

    mobthumbisplay += '<div  class="all_image_manage slider-item active" data-id="'+imgid+'">';
    mobthumbisplay += '<img src="'+imgsrc+'" class="prodimg owl-lazy">';
    mobthumbisplay += "</div>";
  });
  
  console.log("optwhitedisplay :: ", optwhitedisplay);
  
  document.getElementById('optowlimageitemlist').innerHTML = optwhitedisplay;
  document.getElementById('moboptowlimageitemlist').innerHTML = optwhitedisplay;
  document.getElementById('moboptowlimageitemlistthumb').innerHTML = mobthumbisplay;

  var optowlimageitemlist = $('#optowlimageitemlist');
  optowlimageitemlist.trigger('destroy.owl.carousel');
  optowlimageitemlist.html(optowlimageitemlist.find('.owl-stage-outer').html()).removeClass('owl-loaded');
  optowlimageitemlist.owlCarousel({
      loop: true,
      lazyLoad:true,
      nav: true,
      margin: 10,
      dots: true,
      singleItem: true,
      items: 1,
      responsiveClass:true,
      responsive:{
        0:{
          items:1,
          nav:false,
          smartSpeed : 150,
          dots:true,
        },
        500:{
          items:1,
          nav:true,
        }
      }
  });

  var moboptowlimageitemlist = $('#moboptowlimageitemlist');
  moboptowlimageitemlist.trigger('destroy.owl.carousel');
  moboptowlimageitemlist.html(moboptowlimageitemlist.find('.owl-stage-outer').html()).removeClass('owl-loaded');
  moboptowlimageitemlist.owlCarousel({
      loop: true,
      lazyLoad:true,
      nav: true,
      margin: 10,
      dots: true,
      singleItem: true,
      items: 1,
      responsiveClass:true,
      responsive:{
        0:{
          items:1,
          nav:false,
          smartSpeed : 150,
          dots:true,
        },
        500:{
          items:1,
          nav:true,
        }
      }
  });
  
  var $owlthumb = $('.mob-thumb-slider .slider-product-img-carousel');
  $owlthumb.trigger('destroy.owl.carousel');
  $owlthumb.html($owlthumb.find('.owl-stage-outer').html()).removeClass('owl-loaded');
  $owlthumb.owlCarousel({
    loop:true,
    center:true,
    lazyLoad:true,
    margin:0,
    nav:true,
    navText: ["",""],
    dots: false,
    items: 5,
    responsiveClass:true,
    mouseDrag : false,
    touchDrag : false,
    responsive:{
       0:{
          items:3,
          smartSpeed : 150,
          nav:true
       },
       992:{
          items:5,
          nav:true
       }
    }
  });

  renderowlbutton();

}

function renderowlbutton () {
  setTimeout(function(){
    $(".carouselsmall_2 .owl-nav button").click(function(){   
          setTimeout(function(){                        
          $(".slider-item").removeClass('active');
          var img_data_id ;
          var count = 0;
          $(".carouselsmall_2 .active .slider-item").each(function(){
              if(count == -imgindexglobal){ 
              img_data_id = $(this).attr('data-id')
                $(this).addClass("active");
                return false;
              } 
              count++;
          });
        
        var slider_active_id = $(".carouselsmall_2 .slider-item.active").attr('data-id');
          var imgindex1 = 0;
          $(".carousel_2 .owl-item:not(.cloned) .item").each(function(){
          var dataid = $(this).attr("data-id");
          if(slider_active_id == dataid){
              $(".carousel_2").trigger('to.owl.carousel', imgindex1);
              return false;
          } 
          imgindex1++;
          }); 

          }, 0);                     
    });
    $('.carousel_2').on('dragged.owl.carousel', function(event){
          setTimeout(function(){     
              $(".carouselsmall_2 .owl-item:not(.cloned) .slider-item").removeClass('active');
              var img_data_id = $('.carousel_2 .owl-item.active .item').attr('data-id');
              var imgindex1 = 0;
              $(".carouselsmall_2 .owl-item:not(.cloned) .slider-item").each(function(){
                if($(this).attr('data-id') == img_data_id){ 
                      $(this).addClass("active");
                      $(".carouselsmall_2").trigger('to.owl.carousel', imgindex1);
                      return false;                            
                } 
                imgindex1++;
              });
          }, 0);  
    });
    $(document).on('click','.carouselsmall_2 .slider-item',function(){
              setTimeout(function(){     
                $(".carouselsmall_2 .owl-item:not(.cloned) .slider-item").removeClass('active');
                var img_data_id = $('.carousel_2 .owl-item.active .item').attr('data-id');
                var imgindex1 = 0;
                $(".carouselsmall_2 .owl-item:not(.cloned) .slider-item").each(function(){
                    if($(this).attr('data-id') == img_data_id){ 
                          $(this).addClass("active");
                          $(".carouselsmall_2").trigger('to.owl.carousel', imgindex1);
                          return false;                            
                    } 
                    imgindex1++;
                });
              }, 0);  
        });
  }, 500);

  setTimeout(function(){
    $('.product-page-wrapper').removeAttr('style');
  }, 60);

  if($(window).width() < 991){
      $(".slider-product-img-carousel").addClass('owl-carousel owl-theme');
      $('#myBtn').click(function() {
        $(".optionproduct-wrapper").addClass('remove-section');
      });
  }
}
// EOF YWV PRODUCT IMAGE SLIDER SCRIPTS
